import { Outlet } from "react-router-dom";
// import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useNavigationFlow } from "@/hooks/useNavigationFlow";
import { useStrategySessionModal } from "@/hooks/useStrategySessionModal";
import { BookStrategySessionModal } from "@/components/onboarding/BookStrategySessionModal";

export function MainLayout() {
  const { shouldShowContent } = useNavigationFlow();
  const { isOpen, closeModal, handleBook } = useStrategySessionModal();

  // Don't render content while navigation flow is being determined
  if (!shouldShowContent) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <TooltipProvider>
      <div className="flex h-screen bg-sidebar p-1">
        <Sidebar />
        <div className="flex-1 overflow-hidden p-1">
          <div className="flex flex-col h-full rounded-lg shadow-lg border bg-card overflow-hidden">
            {/* <Header /> */}
            <main className="flex-1 overflow-auto px-2 py-4">
              <div className="container mx-auto">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </div>

      <BookStrategySessionModal
        open={isOpen}
        onOpenChange={closeModal}
        onBook={handleBook}
      />
    </TooltipProvider>
  );
}
